import React, { useEffect, useState } from "react";
import { ApiResponse } from "../../../api/master/axiosIndex";
import { phaseApis } from "../../../api/Phase";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import { Card } from "antd";
import ActivityStreamLine from "../activityStreamLine/ActivityStreamLine";

const PhaseActivityStreamLine = ({ activeTab }: { activeTab: string }) => {
  const [activityStreamLineData, setActivityStreamLineData] = useState<any>();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id: projectId, extra: extraData } = location.state || {};
  const {
    data: {
      id: phaseId,
      open: phaseOpen,
      projectResponse: {
        isLocked: lock,
        lockedByName: lockedByUserName,
        updatedDate: lockedOn,
        plannedStartDate: projectStartDate,
        plannedEndDate: projectEndDate,
      },
      allowEdit,
      extra: { status },
    },
  } = useSelector((state: RootState) => state.PhaseInDetailModal);

  useEffect(() => {
    if (activeTab === "activityStream") {
      getStatusTimeLineData();
    }
  }, [activeTab]); 

  const getStatusTimeLineData = async () => {
    try {
      const apiResponse: ApiResponse = await phaseApis.fetchActivityStreamlines(
        projectId,
        phaseId
      );
      const { data, status } = apiResponse;
      if (status) {
        console.log("data", data);
        setActivityStreamLineData(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {activityStreamLineData && (
        <Card className="card-bordered mt-3" style={{ padding: "0px 50px" }}>
          <ActivityStreamLine groupedActivities={activityStreamLineData} />
        </Card>
      )}
    </>
  );
};

export default PhaseActivityStreamLine;